import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { PreviewDocketDialogComponent } from '../dialogs/preview-docket-dialog/preview-docket-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';

@Component({
    selector: 'customer-cell',
    template: ` <a
    *ngIf="params"
    matTooltip="Preview Contract"
    (click)="previewDocket($event)"
    matTooltip-position="left"
    tooltipHideDelay="0"
  >
    <mat-icon>pageview</mat-icon>
  </a>`,
    standalone: true,
    imports: [NgIf, MatTooltip, MatIcon]
})
export class PreviewDocketCellComponent implements AgRendererComponent {
  constructor(private dialog: MatDialog) {}

  params: any;

  agInit(params: any): void {
    if (params.data) {
      this.params = params;
    }
  }

  refresh(params: any): boolean {
    if (params.data) {
      this.params = params;
      return true;
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}

  previewDocket(event) {
    event.stopPropagation();
    const dialogData = {
      docketId: this.params.data.id
    };

    const dialogRef = this.dialog.open(PreviewDocketDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((updateClicked) => {});
  }
}
